module.exports = __webpack_public_path__ + "img/providers.8c9a3f7.svg";